import Breadcrumb, { type Crumb } from "@/components/feature/Breadcrumb";
import Reveal from "@/components/base/Reveal";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  subtitle: string;
  image: string;
  imageAlt: string;
  crumbs: Crumb[];
}

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image,
  imageAlt,
  crumbs,
}: PageHeroProps) {
  return (
    <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
      <img
        src={image}
        alt={imageAlt}
        title={`${title} - 潜声投稿`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/80 to-foreground-950/55"></div>

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-content mx-auto">
          <Reveal>
            <Breadcrumb items={crumbs} tone="dark" />
            {eyebrow && (
              <span className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-accent-300 text-xs tracking-wider">
                <i className="ri-price-tag-3-line"></i>
                {eyebrow}
              </span>
            )}
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight max-w-3xl">
              {title}
            </h1>
            <p className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-background-200">
              {subtitle}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}